export class LeaderboardRecord {
    public userId?: string;
    public name: string;
    public avatar?: string;
    public score: number;
    public countryCode?: string;

    constructor({ userId, name, avatar, score, countryCode }: LeaderboardRecord) {
        this.userId = userId || '';
        this.name = name;
        this.avatar = avatar || '';
        this.score = score;
        this.countryCode = countryCode || '';
    }
}
